import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";

export default function About() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content/about").then((res) => setContent(res.data));
  }, []);

  if (!content) return <div className="pt-40 pb-24 text-center text-muted-foreground">Loading…</div>;

  return (
    <div data-testid="about-page">
      <SEO
        title="About Us"
        description="Learn about PhysioAbhi Healthcare Foundation's mission, story and values as a Section 8 nonprofit delivering accessible physiotherapy in Bengaluru."
        path="/about"
      />
      <PageHeader eyebrow={content.eyebrow} title={content.title} subtitle={content.subtitle} />
      <section className="px-5 md:px-10 py-20">
        <div className="max-w-4xl mx-auto space-y-24">
          {content.chapters.map((c) => (
            <Reveal key={c.num} className="grid grid-cols-1 md:grid-cols-12 gap-8">
              <div className="md:col-span-3">
                <span className="font-heading text-6xl md:text-7xl text-accent/90">{c.num}</span>
              </div>
              <div className="md:col-span-9 md:border-l md:border-border md:pl-10">
                <h3 className="font-heading text-2xl md:text-3xl mb-4">{c.title}</h3>
                <p className="text-muted-foreground leading-relaxed text-base md:text-lg">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-secondary border-t border-border px-5 md:px-10 py-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.features.map((f) => (
            <Reveal key={f.title} className="border border-border p-8 bg-background">
              <h4 className="font-heading text-xl mb-2">{f.title}</h4>
              <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
